import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionsService } from 'app/core/auth/permissions.service';

/**
 * RoleGuard - Protects routes based on the current user's role permissions.
 *
 * Usage in route definition:
 *   data: { routeKey: 'legal.requests' },
 *   canActivate: [AuthGuard, roleGuard]
 *
 * If routeKey is missing from route data, the guard allows access by default
 * (so unprotected routes like profile remain accessible).
 *
 * If the user doesn't have can_view permission for the routeKey, they are
 * redirected to the first screen they can see (see PermissionsService.landingPath).
 */
export const roleGuard: CanActivateFn = (route) => {
    const permissionsService = inject(PermissionsService);
    const router = inject(Router);

    const routeKey: string | undefined = route.data?.['routeKey'];

    // No routeKey means the route doesn't require a specific permission
    if (!routeKey) return true;

    if (permissionsService.canView(routeKey)) {
        return true;
    }

    return router.parseUrl(permissionsService.landingPath());
};
